import axiosClient from 'src/configs/axios.configs';

export const getInfoPackage = () => {
  return axiosClient.get('payment-package-promo/');
};

export const updatePackage = (idPackage) => {
  return axiosClient.post('payment/paymentPackage/' + idPackage);
};
